/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import moment from 'moment';
import { useState } from 'react';
import { parcelStatuses } from '../../constants/enums/ParcelStatuses';
import Swal from 'sweetalert2';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import { toast } from 'react-toastify';
import { convertStringToNumber } from '../../utils/ConvertStringToNumber/convertStringToNumber';
import { convertBase64ToPDF } from '../../utils/Downloader/Downloader';
import { currentUser } from '../../utils/Auth/auth';

const ShipmentWindow = ({
  shipmentData,
  data,
  updateData,
  reloadAfterUpdate = false,
}) => {
  const [currentData, setCurrentData] = useState(shipmentData);
  const { shipment, statement, serviceInfo, user } = currentData;
  const [declineLoading, setDeclineLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [kycLoading, setKycLoading] = useState(false);

  const renewDisplayedData = (shipment) => {
    let originalData = [...data];
    let shipIndex = originalData.findIndex(
      (s) => s.codeA === shipmentData.shipment.codeA,
    );
    if (shipIndex !== -1) {
      originalData[shipIndex] = shipment;
    }
    if (reloadAfterUpdate) window.location.reload();
    updateData(originalData);
  };

  const makeDisplayDataVoid = () => {
    let originalData = [...data];
    let shipIndex = originalData.findIndex(
      (s) => s.codeA === shipmentData.shipment.codeA,
    );

    if (shipIndex !== -1) {
      originalData[shipIndex] = {
        ...originalData[shipIndex],
        status: parcelStatuses.void,
      };
    }

    updateData(originalData);
  };

  const update = async () => {
    if (JSON.stringify(currentData) !== JSON.stringify(shipmentData)) {
      const result = await request({
        url: `${controllers.shipments}updateShipment`,
        body: currentData,
        type: requestTypes.post,
        setLoading: setUpdateLoading,
      });
      if (result?.code === responseTypes.error) {
        toast.error(result.message);
      } else {
        renewDisplayedData(result.result);
        toast.info(result.message);
        Swal.close();
      }
    }
  };

  const getKYC = async () => {
    const result = await request({
      url: `${controllers.documents}blobDocs`,
      params: { id: shipmentData.shipment.id },
      type: requestTypes.get,
      setLoading: setKycLoading,
      disableLogOut: true,
    });
    if (result?.code === responseTypes.error) {
      toast.error(result.message);
    } else {
      const docs = result?.result;
      const fileNames = Object.keys(result?.result);
      fileNames.forEach((element) => {
        convertBase64ToPDF(docs[element], element);
      });
    }
  };

  const decline = async () => {
    if (shipmentData.shipment.status === parcelStatuses.invoiced) {
      const result = await request({
        url: `${controllers.shipments}declineShipment`,
        type: requestTypes.post,
        params: { CV: shipmentData.shipment.codeA },
        setLoading: setDeclineLoading,
      });
      makeDisplayDataVoid();
      Swal.close();
      toast.info(`Parcel ${shipmentData.shipment.codeA} has been declined!`);
    }
  };

  const setFieldValue = (field, subField, currentValue, type = 'string') => {
    const value =
      type === 'number' ? convertStringToNumber(currentValue) : currentValue;
    const nullSection = shipmentData[field] === null;
    const nullValue =
      (shipmentData[field] === null ||
        shipmentData[field][subField] === null) &&
      value === '';

    let settedValue = value;
    if (nullValue) {
      settedValue = null;
    }
    setCurrentData((prevData) => {
      const updatedField =
        nullSection && nullValue
          ? null
          : { ...prevData[field], [subField]: settedValue };
      return { ...prevData, [field]: updatedField };
    });
  };
  return (
    <div>
      <div className="overflow-y-auto p-4 text-[1vw]">
        <div className="flex flex-wrap justify-center">
          <div className="w-full mb-4 font-semibold">Main info</div>

          {/* Code/CV */}
          <div className="flex flex-col">
            <span>Code/CV</span>
            <input
              type="text"
              name="codeCV"
              disabled={true}
              value={shipment?.codeA}
              placeholder="Code/CV..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* First Mile Name */}
          {currentData?.firstMileData1?.courier ? (
            <div className="flex flex-col">
              <span>First Mile Courier</span>
              <input
                type="text"
                name="codeCV"
                disabled={true}
                value={currentData?.firstMileData1?.courier}
                placeholder="Code/CV..."
                className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
              />
            </div>
          ) : (
            <></>
          )}

          {/* First Mile Tracking */}
          {currentData?.firstMileData1?.courierTrackingCode ? (
            <div className="flex flex-col">
              <span>First Mile Tracking</span>
              <input
                type="text"
                name="codeCV"
                disabled={true}
                value={currentData?.firstMileData1?.courierTrackingCode}
                placeholder="Code/CV..."
                className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
              />
            </div>
          ) : (
            <></>
          )}

          {/* First Mile Price */}
          {currentData?.firstMileData1?.amount ? (
            <div className="flex flex-col">
              <span>First Mile Price</span>
              <input
                type="text"
                name="codeCV"
                disabled={true}
                value={`${currentData?.firstMileData1?.amount} ${currentData?.firstMileData1?.currency}`}
                placeholder="Code/CV..."
                className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
              />
            </div>
          ) : (
            <></>
          )}

          {/* Shipment type */}
          <div className="flex flex-col">
            <span>Type</span>
            <input
              type="text"
              name="shipmentType"
              disabled={true}
              value={shipment?.shipmentType}
              placeholder="Type..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Delivery method */}
          <div className="flex flex-col">
            <span>Delivery method</span>
            <input
              type="text"
              name="shipmentSubType"
              disabled={true}
              value={shipment?.sae}
              placeholder="Delivery method..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          <div className="flex flex-col">
            <span>Container</span>
            <input
              type="text"
              name="container"
              value={shipment?.container}
              onChange={(e) =>
                setFieldValue('shipment', 'container', e.target.value)
              }
              placeholder="Container..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Status */}
          <div className="flex flex-col">
            <span>Status</span>
            <select
              type="text"
              name="status"
              value={shipment?.status}
              onChange={(e) =>
                setFieldValue('shipment', 'status', e.target.value)
              }
              placeholder="Status..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            >
              {Object.keys(parcelStatuses).map((item) => (
                <option key={`option-${item}`}>{parcelStatuses[item]}</option>
              ))}
            </select>
          </div>

          {/* Total price */}
          <div className="flex flex-col">
            <span>Total price</span>
            <input
              type="text"
              name="currencyCd"
              disabled={true}
              value={`${shipment.custOwn.toFixed(2)} ${shipment?.currencyCd}`}
              placeholder="Total Price..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Courier fee */}
          {shipmentData.shipment.customerCd === 'OONEW' ? (
            <div className="flex flex-col">
              <span>Courier fee</span>
              <input
                type="text"
                name="currencyCd"
                onChange={(e) =>
                  setFieldValue('shipment', 'carrier', e.target.value, 'number')
                }
                value={shipment.carrier}
                placeholder="Courier fee..."
                className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
              />
            </div>
          ) : null}

          {/* Creation date */}
          <div className="flex flex-col">
            <span>Created at</span>
            <input
              type="text"
              name="createdAt"
              disabled={true}
              value={moment(shipment.firstDt).format('MMM DD, YYYY hh:mmA')}
              placeholder="Created At..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Last Edited */}
          <div className="flex flex-col">
            <span>Last Edited</span>
            <input
              type="text"
              name="lastEdited"
              disabled={true}
              value={moment(shipment.editDt).format('MMM DD, YYYY hh:mmA')}
              placeholder="Last Edited..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Statement */}
          <div className="flex flex-col">
            <span>Statement</span>
            <input
              type="text"
              name="statement"
              value={statement?.name}
              onChange={(e) =>
                setFieldValue('statement', 'name', e.target.value)
              }
              placeholder="Statement..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Shipping service */}
          <div className="flex flex-col">
            <span>Shipping service</span>
            <input
              type="text"
              name="shippingService"
              disabled={true}
              value={serviceInfo?.serviceCode}
              placeholder="Shipping Service..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Value */}
          <div className="flex flex-col">
            <span>Value</span>
            <input
              type="text"
              name="value"
              value={shipment?.value}
              onChange={(e) =>
                setFieldValue('shipment', 'value', e.target.value, 'number')
              }
              placeholder="Customer Code..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>
          {/* Insurance */}
          <div className="flex flex-col">
            <span>Insurance</span>
            <input
              type="text"
              name="shippingService"
              disabled={true}
              value={shipment?.insurance}
              placeholder="Insurance..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Weight */}
          <div className="flex flex-col">
            <span>{`Weight (${shipment?.weightCd})`}</span>
            <input
              type="text"
              disabled={true}
              name="shippingService"
              value={shipment?.weight}
              placeholder="Weight..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Length */}
          <div className="flex flex-col">
            <span>Length</span>
            <input
              type="text"
              name="shippingService"
              disabled={true}
              value={shipment?.volL}
              placeholder="Length..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>
          {/* Width */}
          <div className="flex flex-col">
            <span>Width</span>
            <input
              type="text"
              name="shippingService"
              disabled={true}
              value={shipment?.volW}
              placeholder="Width..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>
          {/* Height */}
          <div className="flex flex-col">
            <span>Height</span>
            <input
              type="text"
              name="shippingService"
              disabled={true}
              value={shipment?.volH}
              placeholder="Height..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          <div className="w-full my-4 font-semibold">Sender</div>

          {/* Customer Code */}
          <div className="flex flex-col">
            <span>Customer Code</span>
            <input
              type="text"
              name="customerCd"
              value={shipment?.customerCd}
              onChange={(e) =>
                setFieldValue('shipment', 'customerCd', e.target.value)
              }
              placeholder="Customer Code..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Last Name */}
          <div className="flex flex-col">
            <span>Last Name</span>
            <input
              type="text"
              name="sLastName"
              value={shipment?.sLastName}
              onChange={(e) =>
                setFieldValue('shipment', 'sLastName', e.target.value)
              }
              placeholder="Last Name..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's First Name */}
          <div className="flex flex-col">
            <span>First Name</span>
            <input
              type="text"
              name="sFirstName"
              value={shipment?.sFirstName}
              onChange={(e) =>
                setFieldValue('shipment', 'sFirstName', e.target.value)
              }
              placeholder="First Name..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Country */}
          <div className="flex flex-col">
            <span>Country</span>
            <input
              type="text"
              name="sCountry"
              disabled={true}
              value={shipment?.sCountry}
              placeholder="Country..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Sender's State */}
          <div className="flex flex-col">
            <span>{'State'}</span>
            <input
              type="text"
              name="sSate"
              disabled={true}
              value={shipment?.sOblast}
              onChange={(e) =>
                setFieldValue('shipment', 'sOblast', e.target.value)
              }
              placeholder="State..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Sender's City */}
          <div className="flex flex-col">
            <span>City</span>
            <input
              type="text"
              name="sCity"
              value={shipment?.sCity}
              onChange={(e) =>
                setFieldValue('shipment', 'sCity', e.target.value)
              }
              placeholder="City..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Address */}
          <div className="flex flex-col">
            <span>Address</span>
            <input
              type="text"
              name="sAddress"
              value={shipment?.sStreet}
              onChange={(e) =>
                setFieldValue('shipment', 'sStreet', e.target.value)
              }
              placeholder="Address..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Apartment */}
          <div className="flex flex-col">
            <span>Apartment</span>
            <input
              type="text"
              name="sApart"
              value={shipment?.sApart}
              onChange={(e) =>
                setFieldValue('shipment', 'sApart', e.target.value)
              }
              placeholder="Apartment..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's House */}
          <div className="flex flex-col">
            <span>House</span>
            <input
              type="text"
              name="sHouse"
              value={shipment?.sHouse}
              onChange={(e) =>
                setFieldValue('shipment', 'sHouse', e.target.value)
              }
              placeholder="House..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's ZIP */}
          <div className="flex flex-col">
            <span>ZIP</span>
            <input
              type="text"
              name="sHouse"
              value={shipment?.sIndex}
              onChange={(e) =>
                setFieldValue('shipment', 'sIndex', e.target.value)
              }
              placeholder="ZIP..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Phone */}
          <div className="flex flex-col">
            <span>Phone</span>
            <input
              type="text"
              name="sPhone"
              value={shipment?.sPhone}
              onChange={(e) =>
                setFieldValue('shipment', 'sPhone', e.target.value)
              }
              placeholder="Phone..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Email */}
          <div className="flex flex-col">
            <span>Email</span>
            <input
              type="email"
              name="sEmail"
              value={shipment?.sEmail}
              onChange={(e) =>
                setFieldValue('shipment', 'sEmail', e.target.value)
              }
              placeholder="Email..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Sender's Birthday */}
          <div className="flex flex-col">
            <span>Birthday</span>
            <input
              type="text"
              name="sBirthday"
              value={
                !user?.birthday
                  ? 'No birthday set'
                  : moment(user?.birthday, 'YYYYMMDD').format('MMM DD, YYYY')
              }
              disabled={true}
              placeholder="Birthday..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          <div className="w-full my-4 font-semibold">Receiver</div>

          {/* Receiver's Last Name */}
          <div className="flex flex-col">
            <span>Last Name</span>
            <input
              type="text"
              name="rLastName"
              value={shipment?.rLastName}
              onChange={(e) =>
                setFieldValue('shipment', 'rLastName', e.target.value)
              }
              placeholder="Last Name..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's First Name */}
          <div className="flex flex-col">
            <span>First Name</span>
            <input
              type="text"
              name="rFirstName"
              value={shipment?.rFirstName}
              onChange={(e) =>
                setFieldValue('shipment', 'rFirstName', e.target.value)
              }
              placeholder="First Name..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's Country */}
          <div className="flex flex-col">
            <span>Country</span>
            <input
              type="text"
              name="rCountry"
              value={shipment?.rCountry}
              disabled="true"
              placeholder="Country..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300 text-gray-500 bg-gray-200"
            />
          </div>

          {/* Receiver's State */}
          <div className="flex flex-col">
            <span>State</span>
            <input
              type="text"
              name="rState"
              value={shipment?.rOblast}
              // disabled={shipment?.rCountry === 'Ukraine'}
              onChange={(e) =>
                setFieldValue('shipment', 'rOblast', e.target.value)
              }
              placeholder="State..."
              className={classNames(
                'p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300',
                // shipment?.rCountry === 'Ukraine' && 'text-gray-500 bg-gray-200',
              )}
            />
          </div>

          {/* Receiver's City */}
          <div className="flex flex-col">
            <span>City</span>
            <input
              maxLength={15}
              type="text"
              name="rState"
              value={shipment?.rCity}
              onChange={(e) =>
                setFieldValue('shipment', 'rCity', e.target.value)
              }
              placeholder="State..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's Address */}
          <div className="flex flex-col">
            <span>Address</span>
            <input
              maxLength={50}
              type="text"
              name="rAddress"
              value={shipment?.rStreet}
              onChange={(e) =>
                setFieldValue('shipment', 'rStreet', e.target.value)
              }
              placeholder="Address..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's Apartment */}
          <div className="flex flex-col">
            <span>Apartment</span>
            <input
              maxLength={15}
              type="text"
              name="rApart"
              value={shipment?.rApart}
              onChange={(e) =>
                setFieldValue('shipment', 'rApart', e.target.value)
              }
              placeholder="Apartment..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's House */}
          <div className="flex flex-col">
            <span>House</span>
            <input
              maxLength={15}
              type="text"
              name="rHouse"
              value={shipment?.rHouse}
              onChange={(e) =>
                setFieldValue('shipment', 'rHouse', e.target.value)
              }
              placeholder="House..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's ZIP */}
          <div className="flex flex-col">
            <span>ZIP</span>
            <input
              type="text"
              name="sHouse"
              value={shipment?.rIndex}
              onChange={(e) =>
                setFieldValue('shipment', 'rIndex', e.target.value)
              }
              placeholder="ZIP..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's Phone */}
          <div className="flex flex-col">
            <span>Phone</span>
            <input
              type="text"
              name="rPhone"
              value={shipment?.rPhone}
              onChange={(e) =>
                setFieldValue('shipment', 'rPhone', e.target.value)
              }
              placeholder="Phone..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Receiver's Email */}
          <div className="flex flex-col">
            <span>Email</span>
            <input
              type="email"
              name="rEmail"
              value={shipment?.rEmail}
              onChange={(e) =>
                setFieldValue('shipment', 'rEmail', e.target.value)
              }
              placeholder="Email..."
              className="p-2 border-b-2 border-gray-300 w-[10vw] focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>
        </div>
      </div>
      <div className="mt-5">
        <div className="float-left relative">
          <div className="min-h-10 text-sm text-yellow-500 overflow-visible whitespace-nowrap flex items-center">
            {shipmentData.shipment.status === parcelStatuses.paid ||
            shipmentData.shipment.status === parcelStatuses.uploaded ? (
              <div className="leading-[15px] text-left">
                Can not decline paid or <br />
                uploaded parcel
              </div>
            ) : (
              <div className="leading-[15px] text-left">
                {shipmentData.shipment.status === parcelStatuses.void ? (
                  <>
                    Parcel has already <br />
                    been declined
                  </>
                ) : null}
              </div>
            )}
          </div>
          {!declineLoading ? (
            <div
              onClick={decline}
              className={classNames(
                'text-white rounded-[5px] p-3 text-sm inline-block float-left ',
                shipmentData.shipment.status === parcelStatuses.invoiced
                  ? 'bg-red-800 cursor-pointer hover:bg-red-900'
                  : 'bg-gray-500',
              )}
            >
              Decline parcel
            </div>
          ) : (
            <img className="w-10 h-10 ml-9" src={loadingGif} />
          )}
        </div>
        <div className="float-right min-w-[130px]">
          {!updateLoading ? (
            <>
              <div className="min-h-10 text-sm text-yellow-500 flex items-center justify-end">
                {JSON.stringify(currentData) === JSON.stringify(shipmentData)
                  ? 'No changes to save'
                  : ''}
              </div>
              <div
                onClick={update}
                className={classNames(
                  'text-white inline-block rounded-[5px] p-3 text-sm float-right',
                  JSON.stringify(currentData) === JSON.stringify(shipmentData)
                    ? 'bg-gray-400'
                    : 'bg-blue-900 cursor-pointer hover:bg-blue-800',
                )}
              >
                Save changes
              </div>
            </>
          ) : (
            <img className="w-10 h-10 mr-9 mt-10" src={loadingGif} />
          )}
        </div>
        <div
          className={classNames(
            'float-right',
            shipmentData.shipment.rCountry !== 'India' || !currentUser.documents
              ? 'hidden'
              : '',
          )}
        >
          {!kycLoading ? (
            <>
              <div className="min-h-10 text-sm text-yellow-500 flex items-center"></div>
              <div
                onClick={getKYC}
                className={classNames(
                  'text-white inline-block rounded-[5px] p-3 text-sm float-right bg-green-900 cursor-pointer hover:bg-green-800 px-5',
                )}
              >
                K Y C
              </div>
            </>
          ) : (
            <img className="w-10 h-10 mr-9 mt-10" src={loadingGif} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ShipmentWindow;
